(function () {
    'use strict';

    angular.module('swif.parcauto')

    .directive('panelAutomobile', ['swifFrameworkService', function (swif) {
        var directive = swif.panel.create_directive('parcauto_automobile');
        directive.templateUrl = 'partials/parcauto/panel-automobile.html';
        var _link = directive.link;
        directive.link = function (scope, element, attr, ngModel) {
            _link(scope, element, attr, ngModel);
            scope.$watch('item.model_id', function (newV) {
                if (newV) {
                    swif.data.get('parcauto_model', newV[0])
                    .then(function (model) {
                        scope.model = model;
                    });
                }
            });
        };
        return directive;
    }])

    .component('panelModel', {
        templateUrl: 'partials/parcauto/panel-model.html',
        controller: panelModelController,
        bindings: {
            modelId: '='
        }
    });

    function panelModelController(swif) {
        var $ctrl = this;
        if ($ctrl.modelId) {
            swif.data.get('parcauto_model', this.modelId)
                .then(function (modele) {
                    $ctrl.item = modele;
                });
        }
    }


})();
